// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"4c9d97a6","239":"e39fb35b","455":"492e6b75","977":"4b3215a8"}[chunkId] + ".chunk.js";
};